module.exports = __webpack_public_path__ + "img/anodynelogocover.739da14e.png";